const PLACEHOLDER_SRC = `data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D`
export const PRODUCT_META_ICON = {
  bedrooms: "bed-blocks",
  wc: "wc",
  area: "area",
  floor: "floor",
  determine: "determine",
  ownership: "ownership",
  floorNumber: "floor-number",
  determineBlocks: "determine-blocks",
  view: "view",
  ruler:"ruler",
  "building-2": "building-2",
  "grid-2x2": "grid-2x2",
  "gallery-horizontal-end": "gallery-horizontal-end",
} as const;

export type ProductMetaKey = keyof typeof PRODUCT_META_ICON;


export const determineType = [{
  "key": 1,
  "label": "Tây Bắc"
},
{
  "key": 2,
  "label": "Tây Nam"
},
{
  "key": 3,
  "label": "Đông Bắc"
},
{
  "key": 4,
  "label": "Đông Nam"
},
{
  "key": 5,
  "label": "Hướng Tây"
},
{
  "key": 6,
  "label": "Hướng Đông"
},
{
  "key": 7,
  "label": "Hướng Nam"
},
{
  "key": 8,
  "label": "Hướng Bắc"
}

]
export const ownershipType = [

  {
    "key": 0,
    "label": "Sổ đỏ"
  },
  {
    "key": 1,
    "label": "Sổ hồng"
  },
  {
    "key": 2,
    "label": "Chưa có sổ"
  },
  {
    "key": 3,
    "label": "Giấy tờ chuyển nhượng"
  }
]

export const legalStatuse = [
  {
    "key": 1,
    "label": "Hợp đồng mua bán"
  }
]
export const determineBlockConstants = [
  {
    "key": 1,
    "label": "Bên trái"
  },
  {
    "key": 2,
    "label": "Bên phải"
  },
  {
    "key": 3,
    "label": "Ở giữa"
  }
]


export const determineBlocks = [
  {
    "key": 1,
    "label": "Bên trái"
  },
  {
    "key": 2,
    "label": "Bên phải"
  },
  {
    "key": 3,
    "label": "Ở giữa"
  }
]

export const views= [
  {
    "key": 1,
    "label": "Toàn cảnh"
  },
  {
    "key": 2,
    "label": "Thành phố"
  },
  {
    "key": 3,
    "label": "Sông"
  },
  {
    "key": 4,
    "label": "Công viên"
  },
  {
    "key": 5,
    "label": "Biển"
  },
  {
    "key": 6,
    "label": "Núi"
  },
  {
    "key": 7,
    "label": "Vườn"
  },
  {
    "key": 8,
    "label": "Hồ bơi"
  }
]
